import { render, staticRenderFns } from "./MisTickets.vue?vue&type=template&id=1c337a4c"
import script from "./MisTickets.vue?vue&type=script&lang=js"
export * from "./MisTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports